import { Redirect, useLocation } from "react-router-dom";

import { Layout } from "~/v2/components/Layout";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import CoinTransfers from "./index";
import CoinTransfersWhitelistAddress from "./whitelistAddress";

export const CoinTransfersRoute = () => {
  const isTokenizedEquityTrading = useFeatureEnabled(
    FeatureFlags.TOKENIZED_EQUITY_TRADING,
  );

  if (isTokenizedEquityTrading) {
    return <Redirect to={Path.ROUTE_DIGITAL_ASSETS_TRANSFERS} />;
  }

  return <Layout requireMFAForAllAccounts={true} component={CoinTransfers} />;
};

export const CoinTransfersWhitelistAddressRoute = () => {
  const location = useLocation();
  const isTokenizedEquityTrading = useFeatureEnabled(
    FeatureFlags.TOKENIZED_EQUITY_TRADING,
  );

  if (isTokenizedEquityTrading) {
    return (
      <Redirect
        to={{
          pathname: Path.ROUTE_DIGITAL_ASSETS_WHITELIST_ADDRESS,
          search: location.search,
        }}
      />
    );
  }

  return (
    <Layout
      showSearchInHeader={false}
      noHeader={true}
      disableAppMenu={true}
      requireMFAForAllAccounts={true}
      component={CoinTransfersWhitelistAddress}
    />
  );
};
